import React from 'react'

const CaratIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      className="carat-icon"
      x1="2.5"
      y1="6.79"
      x2="12.92"
      y2="17.21"
      fill="none"
      stroke="#666"
    />
    <line
      className="carat-icon"
      x1="11.08"
      y1="17.21"
      x2="21.5"
      y2="6.79"
      fill="none"
      stroke="#666"
    />
  </svg>
)

export default CaratIcon



// WEBPACK FOOTER //
// ./src/components/assets/CaratIcon.js